// extracted by mini-css-extract-plugin
export default {"listClassName":"DocumentsList_listClassName__BBXfE","mainContainer":"DocumentsList_mainContainer__hM8+H","mainFlex":"DocumentsList_mainFlex__GXjqV"};